export default "__VITE_ASSET__4RHudpUS__"